import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Loads an authenticated image as a blob URL (img tags cannot send cookies cross-origin reliably).
export const AuthImg = ({ path, version, alt, className, testId }) => {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url;
    let live = true;
    api.get(path, { responseType: "blob", params: { v: version } })
      .then((r) => {
        url = URL.createObjectURL(r.data);
        if (live) setSrc(url);
      })
      .catch(() => setSrc(""));
    return () => {
      live = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path, version]);
  if (!src) return <div className={`${className} bg-black/10 animate-pulse`} data-testid={testId} />;
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};
